var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-8 h-6 text-center font-bold rounded ml-1 bg-white",class:_vm.isLowQuantity ? 'text-orange-600' : 'text-blue-500'},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }